class CardSelect extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onCardVariantChange);
  }
  onCardVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateMedia();
  
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll("field"), (element) => {
      return Array.from(element.querySelectorAll("input")).find(
        (radio) => radio.checked
      )?.value;
    });
  }
  updateMasterId(){
      this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }
  updateMedia(){
   var currentImageDom = this.closest('.card--media').querySelector(' img');

  if(!currentImageDom)
    return


         currentImageDom.setAttribute('srcset', this.currentVariant.featured_image.src);
        currentImageDom.setAttribute('src', this.currentVariant.featured_image.src);
  }
    getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define("card-variant", CardSelect);
